<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="leitoHistoricoModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="leitoHistoricoModalTitle">Histórico de Leitos</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!internacao" :loading="true" />

                        <template v-else>
                            <div class="card">
                                <div class="card-body">
                                    <celula-dados-paciente :hor="{ 
                                                marcacao: { 
                                                    plano: internacao.plano,
                                                    paciente: internacao.paciente
                                                }
                                            }" />
                                </div>
                            </div>

                            <div class="alert alert-secondary">
                                #{{ internacao.id_internacao }}
                            </div>

                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th>Leito</th>
                                        <th>Entrada</th>
                                        <th>Saída</th>
                                        <th>Duração</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in internacao.leito_historico" :key="index">
                                        <td>{{ item.local.search }}</td>
                                        <td>
                                            {{ $util.getFormatDate(item.dt_entrada) }} 
                                            {{ item.dt_entrada.slice(11, 16) }}
                                            <span class="small text-muted ml-2">
                                                {{ $util.getFormatDate(item.dt_entrada, 'ddd') }}
                                            </span>
                                        </td>
                                        <td>
                                            <template v-if="item.dt_saida">
                                                {{ $util.getFormatDate(item.dt_saida) }} {{ item.dt_saida.slice(11, 16) }}
                                                <span class="small text-muted ml-2">
                                                    {{ $util.getFormatDate(item.dt_saida, 'ddd') }}
                                                </span>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="item.dt_saida">
                                                {{ duracao(item.dt_entrada, item.dt_saida) }} dia(s)
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import * as moment from "moment";
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';

export default {
    data() {
        return { 
            internacao: null, 
            chave: "", 
        }
    },

    components: { 
        AzEmptyState, 
        CelulaDadosPaciente
    },

    computed: { 
        modal_name: function () { 
            return 'leitoHistoricoModal' + this.chave;
        }
    },

    methods: { 
        fechar_modal() { 
            $('#' + this.modal_name).modal('hide');
        },

        duracao (entrada, saida) { 
            return moment
                    .duration(moment(saida, "YYYY-MM-DD").diff(moment(entrada, "YYYY-MM-DD")))
                    .asDays();
        },

        abrir (id_internacao) { 
            this.internacao = null; 

            $('#' + this.modal_name).modal('show');

            this.$util.load(this, { 
                service: 'internacaos',
                func: 'show', 
                parms: { 
                    id: id_internacao,
                    historico: true, 
                },
                loadTo: res => { 
                    console.log('internacao', res);
                    this.internacao = res;
                }
            })
        }
    },

    mounted() { 
        this.chave = this.$util.uuidv4(); 
    }
}
</script>
